import { colorIndex, initials } from '../../lib/format.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-avatar ---
let __fez_component_0;
{

__fez_component_0 = class {
  NAME = 'span'

  PROPS = {
    user: Object,
    name: String,
    src: String,
    size: { type: String, default: 'md', enum: ['xs', 'sm', 'md', 'lg', 'xl'] },
    presence: Boolean,
  }

  init() {
    this.state.failed = ''
  }

  beforeRender() {
    const user = this.props.user || {}
    this.state.label = user.display_name || user.name || this.props.name || ''
    this.state.src = user.avatar || this.props.src || ''
    this.state.initials = initials(this.state.label)
    this.state.color = colorIndex(user.ref || this.state.label)
    const ref = this.props.presence ? user.ref : ''
    if (ref && ref !== this.state.watched) {
      this.state.watched = ref
      window.App?.watchPresence?.([ref])
    }
    this.state.presence = ref ? this.globalState[`presence:${ref}`] || '' : ''
    this.state.dnd = Boolean(user.dnd?.active)
    this.state.presenceLabel = this.state.dnd ? 'Notifications paused' : this.state.presence === 'active' ? 'Active' : 'Away'
  }

  broken() {
    this.state.failed = this.state.src
  }

  CSS = `:fez {
position:relative;display:inline-flex;flex-shrink:0;vertical-align:middle;.avatar{display:inline-flex;align-items:center;justify-content:center;overflow:hidden;border-radius:var(--radius-md);color:var(--color-accent-text);font-weight:var(--weight-bold);letter-spacing:0.02em;user-select:none;.initials{color:var(--color-accent-text) !important}img{width:100%;height:100%;object-fit:cover;display:block}}.xs{width:20px;height:20px;font-size:var(--text-2xs);border-radius:var(--radius-sm)}.sm{width:24px;height:24px;font-size:var(--text-2xs);border-radius:var(--radius-sm)}.md{width:36px;height:36px;font-size:var(--text-sm)}.lg{width:72px;height:72px;font-size:var(--text-xl);border-radius:var(--radius-lg)}.xl{width:96px;height:96px;font-size:var(--text-2xl);border-radius:var(--radius-xl)}.presence{position:absolute;right:-2px;bottom:-2px;display:grid;place-items:center;width:10px;height:10px;border-radius:var(--radius-full);box-shadow:0 0 0 2px var(--avatar-ring,var(--color-bg));background:var(--color-presence-active);&.away{border:2px solid var(--color-presence-away);background:var(--avatar-ring,var(--color-bg))}&.md{width:12px;height:12px}&.lg{width:18px;height:18px;right:0;bottom:0;box-shadow:0 0 0 3px var(--avatar-ring,var(--color-bg))}&.xl{width:22px;height:22px;right:2px;bottom:2px;box-shadow:0 0 0 4px var(--avatar-ring,var(--color-bg))}&.dnd{min-width:13px;height:13px;border:0;color:var(--color-text-inverse);font-size:var(--text-2xs);font-weight:var(--weight-bold);line-height:1;&.away{background:var(--color-presence-away)}}&.dnd.lg,&.dnd.xl{min-width:18px;height:18px}}.c1{background:var(--color-avatar-1)}.c2{background:var(--color-avatar-2)}.c3{background:var(--color-avatar-3)}.c4{background:var(--color-avatar-4)}.c5{background:var(--color-avatar-5)}.c6{background:var(--color-avatar-6)}.c7{background:var(--color-avatar-7)}.c8{background:var(--color-avatar-8)}
}`

  HTML = `<span class="avatar {props.size} c{state.color}" title={state.label}>
{#if state.src && state.failed !== state.src}
<img src={state.src} alt={state.label} onerror="fez.broken()" referrerpolicy="no-referrer" />
{:else}
<span class="initials" aria-hidden="true">{state.initials}</span>
<span class="sr-only">{state.label}</span>
{/if}
</span>
{#if state.presence}
<span class="presence {props.size} {state.presence}" class:dnd={state.dnd} role="img" aria-label={state.presenceLabel} title={state.presenceLabel}>{state.dnd ? 'z' : ''}</span>
{/if}`
};
}

Fez('ui-avatar', __fez_component_0);

export default __fez_component_0;
